window.shop = {
    base: {},
    checkout: {},
    product: {},
    cart: {},
    abandoned_cart: {},
    review: {},
    landing_page: {},
    customer_gift_email: {}
}